"use client";
import * as React from "react";
const SvgEditFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 12.67V16h3.33l9.83-9.83-3.33-3.33zm15.74-9.08a.9.9 0 0 0 0-1.25L13.66.26a.9.9 0 0 0-1.25 0l-1.63 1.63 3.33 3.33z" }));
export {
  SvgEditFilled as default
};
